import { COLUMN_TYPES, ROW_ENTITY_TYPES } from "Boards/const";

export const getCanEditCell = ({ entityType, typeDictID }) => {
  const isAdditionalName =
    entityType === ROW_ENTITY_TYPES.SIGNUP_ADDITIONAL_NAME;

  if (isAdditionalName) {
    // Additional Names can currently only edit "basic" columns
    const editableColumnTypesForAdditionalNames = [
      COLUMN_TYPES.BOOL,
      COLUMN_TYPES.TEXT,
      COLUMN_TYPES.NUMBER,
    ];
    if (editableColumnTypesForAdditionalNames.includes(typeDictID)) {
      return true;
    }

    return false;
  }

  return true;
};
